import React from "react";
import { createSlice } from "@reduxjs/toolkit";


const obj = {
    agentId: "",
    agentName: "",
    channel: "",
    mobileNo: "",
    emailIId: "",
    branchId: "",
    employeeCodeOrSPCode: "",
    employeeNameOrSPName: "",
    parentagencyname: "",
    mappedirdalocation: "",
    businesscreditchannel: "",
    pan: "",
    parentagencyid: "",
    flowType:"advisor",
    businessFor:"",
    skip: false,
    authorization: false,
    refA:"",
    refB:"",
    refC:""
}

const logdata={
agentid:"",
intermedsubcatcd:""
}

const initialState = {
  agentData: obj,
  loginData: logdata
};

export const IntermediaryReducer = createSlice({
  name: "Intermediary",
  initialState,
  reducers: {
    InitialState: () => initialState,
    agentDataSelected: (state, action) => {
        state.agentData = action.payload
    },  
    intersubcatSelected: (state, action) => {
      state.loginData = action.payload
  },  
  },
});

export const {
  InitialState,
  agentDataSelected,
  intersubcatSelected
} = IntermediaryReducer.actions;

export default IntermediaryReducer.reducer;
